module.exports = __webpack_public_path__ + "063ca14569fd13fb7f37a24d70d12e66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/northwestern_university_2023_chart.png
// module id = 1701
// module chunks = 0